// components/Navbar.jsx
import React, { useState } from 'react';
import logo from '../images/logo.png'

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white backdrop-blur-sm border-b border-[#e8eeec]">
      <div className="max-w-[1200px] mx-auto px-8 flex items-center justify-between h-[70px]">
        <div className="flex items-center gap-2.5">
          <div className="w-[120px] h-[120px] rounded-xl flex items-center justify-center">
            <img src={logo} alt="SRM Diagnostic Center Logo" className="w-[70px] h-[70px]"/>
          </div>
          <div>
            <h2 className="text-charcoal text-lg font-serif tracking-tight">SRM Diagnostic</h2>
            <p className="text-[0.7rem] text-[#6b8a87] tracking-[1.5px] uppercase font-medium">Center · Dehradun</p>
          </div>
        </div>
        
        <ul className={`nav-links ${mobileMenuOpen ? 'flex' : 'hidden'} md:flex md:relative md:top-auto md:left-auto md:right-auto md:bg-transparent md:p-0 md:gap-8 md:border-none md:flex-row absolute top-[70px] left-0 right-0 bg-white p-8 gap-4 border-b border-[#e8eeec] flex-col`}>
          <li><a href="#services" className="text-[#4a6662] font-medium hover:text-teal transition-colors">Services</a></li>
          <li><a href="#tests" className="text-[#4a6662] font-medium hover:text-teal transition-colors">Tests</a></li>
          <li><a href="#process" className="text-[#4a6662] font-medium hover:text-teal transition-colors">How It Works</a></li>
          <li><a href="#contact" className="text-[#4a6662] font-medium hover:text-teal transition-colors">Contact</a></li>
        </ul>
        
        <a href="#contact" className="hidden md:inline-block bg-teal text-white px-5 py-2 rounded-lg font-medium text-sm hover:bg-teal-dark transition-colors">Book a Test</a>
        
        <div className="hamburger md:hidden flex flex-col gap-1.5 cursor-pointer" onClick={toggleMenu}>
          <span className="w-6 h-0.5 bg-charcoal rounded"></span>
          <span className="w-6 h-0.5 bg-charcoal rounded"></span>
          <span className="w-6 h-0.5 bg-charcoal rounded"></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;